import Routes from "./Routes";
import useI18n from "./hooks/use-i18n";
import { Analytics } from "@vercel/analytics/react";

function App() {
  useI18n();
  return (
    <>
      <Routes />
      <Analytics />
    </>
  );
}

export default App;
